export default {
  text: 'black',
  primary: '#8a1b01',
  secondary: 'lightgrey',
  background: '#ffffff',
  backgroundSecondary: '#fdfdfd',
  light: '#FFF',
  dark: '#4a4a4a'
}
